// Merkezi stok durumu — buradan güncellemek yeterli.
// Stokta olan modellerin slug listesi:
export const IN_STOCK_SLUGS = new Set(["nd72360", "nd72450"]);

export function isInStock(slug) {
  return IN_STOCK_SLUGS.has(slug);
}
